export const getDefaultSize = (isOneSize: boolean, sizeOptions: ProductDetail.ISizeOption[]) => {
  return (isOneSize && sizeOptions.length > 0) || sizeOptions.length === 1
    ? sizeOptions[0]
    : undefined;
};

export const getDynamicCategoryLevels = (
  categories: {
    [key: string]: { id: string; name: string };
  } = {}
) => {
  const categoryKeys = Object.keys(categories).sort();
  const levels: { [key: string]: string } = {};

  if (categoryKeys.length == 0) return {};

  for (let i = 1; i < categoryKeys.length; i++) {
    levels[`categoryLevel${i}`] = categories[categoryKeys[i]]?.name;
  }
  return levels;
};
